export const services = [
  {
    num: '01',
    title: 'General Management & Operations',
    description: "The heart of it all. Take the weight of day-to-day running off your shoulders — coordinating people, workflow and priorities so the business moves without you holding every thread.",
    tag: 'Core skill',
    icon: 'ClipboardList',
  },
  {
    num: '02',
    title: 'Systems & Standard Operating Procedures',
    description: "How your business actually works, turned into clear, repeatable procedures — so quality holds steady whether you're on the tools or on holiday.",
    tag: 'Core skill',
    icon: 'Files',
  },
  {
    num: '03',
    title: 'Accounting Support',
    description: 'Reconciliations, invoicing, payables and month-end tidy-ups kept accurate and on time, ready for your accountant at year end.',
    icon: 'Calculator',
  },
  {
    num: '04',
    title: 'Business Advisory',
    description: 'A steady sounding board for the big calls. Practical advice on structure, cashflow and growth to help you build with confidence.',
    icon: 'Compass',
  },
  {
    num: '05',
    title: 'Project Management for Trades',
    description: 'Scheduling, subbies, materials and client updates handled — so jobs stay on programme, on budget and off your phone at night.',
    icon: 'HardHat',
  },
  {
    num: '06',
    title: 'Procurement',
    description: 'Sourcing, supplier negotiation and purchasing managed to protect your margin and keep the right stock and materials flowing.',
    icon: 'ShoppingCart',
  },
];

export const steps = [
  {
    numeral: 'Step 1',
    title: 'A conversation',
    description: "It starts with a no-pressure, face-to-face chat about where your business is, what's grinding, and where you want to be.",
  },
  {
    numeral: 'Step 2',
    title: 'A focused plan',
    description: 'You get a short, honest plan — the few things worth doing first, scoped to a 5–15 hour weekly contract.',
  },
  {
    numeral: 'Step 3',
    title: 'Hands on the work',
    description: 'Hands-on help each week — running operations, tidying systems and clearing the backlog.',
  },
  {
    numeral: 'Step 4',
    title: 'Room to grow',
    description: 'As the systems take hold, you spend less time managing and more time doing the work you love.',
  },
];

export const stats = [
  { value: '5–15', label: 'Hours / week' },
  { value: '15+', label: 'Years management & operations experience' },
];

export const highlights = [
  {
    title: 'Reasonable rates',
    description: 'Competitive with industry standards — including a free face-to-face chat to get started.',
  },
  {
    title: 'References on request',
    description: 'Many recommendations and referee phone numbers are available on request.',
  },
];

export const navLinks = [
  { label: 'Services', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'How it works', href: '#how' },
  { label: 'Contact', href: '#contact' },
];

export const images = {
  hero: '/catherine-kayak.jpg',
  landscape: '/about-coastal.jpg',
  plans: '/process-frosty-river.jpg',
};
